module.exports = "/content/fc9eacfb1a254309c592976f430fcc6e.png";